<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M12 11.38q-1.23 0-2.12-.88A3 3 0 0 1 9 8.38q0-1.24.88-2.11.89-.9 2.12-.89 1.23 0 2.12.89.88.88.88 2.11 0 1.25-.88 2.12-.89.89-2.12.88m-7 7.24v-1.65q0-.62.36-1.16t.97-.84q1.41-.68 2.83-1.02a12 12 0 0 1 5.68 0q1.41.34 2.83 1.02.6.3.97.84.36.54.36 1.16v1.65zm1-1h12v-.65q0-.33-.21-.63-.23-.3-.6-.49-1.23-.6-2.54-.92a11 11 0 0 0-5.3 0q-1.3.33-2.54.92-.37.2-.6.5-.21.29-.21.62zm6-7.24q.83 0 1.41-.58.6-.6.59-1.42 0-.83-.59-1.4-.59-.6-1.41-.6-.83 0-1.41.6-.6.57-.59 1.4 0 .83.59 1.42.59.58 1.41.58"
      />
    </svg>
  </span>
</template>
